"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecursoCriticoChaveFiltro = void 0;
var RecursoCriticoChaveFiltro = /** @class */ (function () {
    function RecursoCriticoChaveFiltro(_id, material, data, fabrica, chave) {
        if (_id === void 0) { _id = { m: '', d: '', f: '', t: '', c: '', ctch: '' }; }
        if (material === void 0) { material = ''; }
        if (data === void 0) { data = ''; }
        if (fabrica === void 0) { fabrica = ''; }
        this._id = _id;
        this.material = material;
        this.data = data;
        this.fabrica = fabrica;
        this.chave = chave;
    }
    return RecursoCriticoChaveFiltro;
}());
exports.RecursoCriticoChaveFiltro = RecursoCriticoChaveFiltro;
//# sourceMappingURL=RecursoCriticoChaveFiltro.js.map